import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, Phone } from "@phosphor-icons/react";

const NAV = [
  { label: "Pricing", href: "#services" },
  { label: "Areas", href: "#areas" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container-pd flex items-center justify-between h-24 lg:h-28">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="/logo.png"
            alt="Velocity Cleaning and Maintenance"
            className="h-16 sm:h-20 lg:h-24 w-auto"
          />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="text-sm text-zinc-300 hover:text-white transition-colors tracking-wide"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+61423004480"
            data-testid="header-phone-link"
            className="hidden lg:flex items-center gap-2 text-sm text-zinc-300 hover:text-[#D4AF37] transition-colors"
          >
            <Phone size={16} weight="bold" />
            0423 004 480
          </a>
          <a href="#quote" data-testid="header-quote-btn" className="btn-primary hidden md:inline-flex !py-3 !px-5 text-xs">
            Get a Quote
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden bg-[#050505] border-t border-white/5"
          >
            <div className="container-pd py-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                  className="text-base text-zinc-200 py-2 border-b border-white/5"
                >
                  {n.label}
                </a>
              ))}
              <a href="#quote" onClick={() => setOpen(false)} data-testid="mobile-quote-btn" className="btn-primary mt-2">
                Get a Quote
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
